// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import sheetIcon from 'images/sheet.png'

class Options extends React.Component {
  static propTypes = {
    hasHighlighted: bool.isRequired,
    idRoot: string.isRequired,
    isOpen: bool.isRequired,
    setModalTemplate: func.isRequired,
    sourceForm: string.isRequired,
  }

  optionClasses = hasPermission => (
    `menu-option ${!hasPermission ? 'cursor-not-allowed' : 'pointer'}`
  )

  triggerModalTemplate = templateName => {
    const {
      hasHighlighted,
      setModalTemplate,
    } = this.props

    // if there aren't any projects highlighted, ignore the click
    if (!hasHighlighted) {
      return
    }

    setModalTemplate(templateName)
  }

  triggerExportReportModal = () => this.triggerModalTemplate('export-report')

  render () {
    const {
      optionClasses,
      triggerExportReportModal,
    } = this

    const {
      hasHighlighted,
      idRoot,
      isOpen,
    } = this.props

    return (
      <ul className={`menu-options ${isOpen ? ' active' : ''}`}>
        <li
          className={optionClasses(hasHighlighted)}
          id={`${idRoot}generate-report`}
          onClick={triggerExportReportModal}>
          <img src={sheetIcon} />
          <span>{'Generate Report'}</span>
        </li>
      </ul>
    )
  }
}

export default Options
